// theme.js - Manages theme-related functionality

/**
 * Sets up theme toggling and initialization
 */
function setupTheme() {
    const themeToggle = document.getElementById("themeToggle");

    if (themeToggle) {
        themeToggle.addEventListener("click", toggleTheme);
    }

    loadTheme();
}

/**
 * Toggles between light and dark themes
 */
function toggleTheme() {
    const currentTheme = localStorage.getItem("theme") || "light";
    const newTheme = currentTheme === "light" ? "dark" : "light";
    setTheme(newTheme);
}

/**
 * Sets the theme and saves it to localStorage
 * @param {string} theme - The theme to set ("light" or "dark")
 */
function setTheme(theme) {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
}

/**
 * Loads the saved theme from localStorage or uses system preference
 */
function loadTheme() {
    const savedTheme = localStorage.getItem("theme");
    const themeToggle = document.getElementById("themeToggle");
    
    if (savedTheme) {
        document.documentElement.setAttribute("data-theme", savedTheme);
        if (themeToggle) themeToggle.textContent = "🌓";
    } else if (
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
        document.documentElement.setAttribute("data-theme", "dark");
        if (themeToggle) themeToggle.textContent = "🌓";
    }
}

// Export functions
export {
    setupTheme,
    toggleTheme,
    setTheme,
    loadTheme
};